module.exports = __webpack_public_path__ + "static/Gelion-SemiBold-288480b704b52173b642af77e54fc366.ttf";